import DOMPurify from "dompurify";

export const noImageRenderer = {
    image() {
        return "";
    },
};

export const CHAT_SANITIZE_CONFIG = {
    ADD_ATTR: ["target", "ref"],
    FORBID_TAGS: ["img"],
};

export function sanitizeForChat(html, extraConfig = {}) {
    return DOMPurify.sanitize(html, {
        ...CHAT_SANITIZE_CONFIG,
        ...extraConfig,
    });
}
